import React from 'react';
import Checkbox from '@mui/joy/Checkbox';
import FormHelperText from '@mui/joy/FormHelperText';
import Stack from '@mui/joy/Stack';
import Grid from '@mui/joy/Grid';
import { FieldLabelRow } from './LabelUserpilotHook';

interface Props {
  mdCol?: number;
  options: Array<{
    value: string;
    label: string;
    mdCol?: number;
    disabled?: boolean;
    onChecked?: (e: boolean) => void;
    subContent?: any;
    activeContent?: any;
  }>;
  form: any;
  tooltips?: string;
  className?: string;
  label?: string;
  logo?: string;
  isMissing?: any;
  columns?: number;
  justifyContent?: string;
  verticalLayout?: boolean;
  gridGap?: any;
  disabled?: boolean;
  /** Stable Userpilot spotlight hook. Do not derive from class names. */
  dataUp?: string;
}

const GroupCheckbox = (props: Props) => {
  let gridGap = {};
  if (props.gridGap!==undefined) {
    gridGap =  { gap: `${props.gridGap}`};
  }
  
  return (
    <div
      className={['userpilot-field-root', props.className].filter(Boolean).join(' ')}
      data-up={props.label ? undefined : props.dataUp}
      style={{
        gap: '16px',
        padding: '16px',
        border: props.isMissing ? '1px solid #DC2626' : 'none',
        borderRadius: '8px',
        backgroundColor: props.isMissing ? '#FEF2F2' : 'transparent',
      }}
    >
      {props.label && (
        <FieldLabelRow
          label={props.label}
          logo={props.logo}
          dataUp={props.dataUp}
          isMissing={props.isMissing}
        />
      )}
      {props.tooltips && (
        <FormHelperText sx={{ fontSize: '14px', color: '#6B7280', marginBottom: '10px' }}>
          {props.tooltips}
        </FormHelperText>
      )}
      <Stack direction="column" spacing={1} sx={{ pl: 1 }}>
        <Grid container rowSpacing={1} justifyContent={props.justifyContent || 'flex-start'}
          sx={gridGap}
        >
          {props.options.map((option) => {
            let handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
              props.form.setFieldValue(option.value, e.target.checked);
              option.onChecked && option.onChecked(e.target.checked);
            };
            const groupValues = option.value.split('.');
            const isChecked = option.value.includes('.')
              ? props.form.values[groupValues[0]][groupValues[1]]
              : props.form.values[option.value];
            return (
              <Grid
                xs={12}
                md={props.columns ? 12 / props.columns : props.verticalLayout ? 12 : 'auto'}
                key={option.value}
                sx={{padding:'7px 0px'}}
              >
                <div>
                  {isChecked && option.activeContent && (
                    <div className="sized70">{option.activeContent}</div>
                  )}
                  <Checkbox
                    name={option.value}
                    disabled={option.disabled || props.disabled}
                    checked={isChecked}
                    onChange={handleChange}
                    label={option.label}
                    size="md"
                    color={props.isMissing ? 'danger' : 'primary'}
                    variant="outlined"
                    sx={{ minWidth: 120, alignItems: 'flex-start' }}
                  />
                  {option.subContent}
                </div>
              </Grid>
            );
          })}
        </Grid>
      </Stack>
      {props.isMissing && (
        <FormHelperText sx={{ color: '#DC2626', fontSize: '12px' }}>
          This field is required.
        </FormHelperText>
      )}
    </div>
  );
};

export default GroupCheckbox;
